import React from "react";
import { useState, useEffect, useRef, useContext } from 'react';
import { UserContext } from "../context";
import axios from 'axios';
import { Button, Label, Table, Modal, } from 'flowbite-react';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { CsvExportModule } from 'ag-grid-community';
import Validate from "../shared/validation/Validate";
import { toast } from 'react-toastify';
import { ImCross } from "react-icons/im";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { IoIosSearch } from "react-icons/io";
import Loader from "../shared/Loader/Loader";
import { useNavigate } from "react-router-dom";


const EditableInvioce = ({ modalData, setModalData, setOpenModal, currencyRates, updateTransactionReport }) => {
    return (
        <div className="space-y-10 invoice-to-print">
            <ImCross className='ml-auto cross-icon' onClick={() => setOpenModal(false)} />
            <h2 className={`text-center font-bold text-xl `}>Edit Record</h2>
            <div className="space-y-3">
                <div className={`flex justify-start pb-4 `}>
                    <div className={`print-bold`}>
                        <h1 className='font-semibold'>Currency</h1>
                        <h1 className=''>63 Swanstom ST,</h1>

                    </div>
                </div>
                <div className={`grid grid-cols-2 text-sm `}>
                    <div className='print-bold'>
                        Date: {modalData.localDate}
                    </div>
                    <div className="text-right mr-4 print-bold">
                        Time: {modalData.time}
                    </div>
                </div>
                {/* <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Shop Name:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input className=" text-right" defaultValue='63 Swanstom ST' />
                    </div>
                </div> */}
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Transaction No #:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input className=" text-right" onChange={(e) => modalData.transactionId = e.target.value} defaultValue={modalData.transactionId} />
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Customer Phone #:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input className=" text-right" onChange={(e) => modalData.customerPhoneNumber = e.target.value} defaultValue={modalData.customerPhoneNumber} />
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Transaction Type #:
                    </div>
                    <div className="item-right text-headings p-0 m-0 print-bold">
                        <select onChange={(e) => modalData.transactionMode = e.target.value} className="h-10 border-0 active:border-0 p-0">
                            <option className="">{modalData.transactionMode}</option>
                            <option>{modalData.transactionMode === 'Buy' ? "Sell" : "Buy"}</option>
                        </select>
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Currency #:
                    </div>
                    <div className="item-right text-headings p-0 m-0 print-bold">
                        <select onChange={(e) => modalData.currency = e.target.value} className="h-10 w-24 border-0 active:border-0 p-0">
                            <option defaultChecked className="">{modalData.currency}</option>
                            {currencyRates.map((value) => (
                                <option className="pl-3" key={value._id} value={value.currency} >{value.currency}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Amount:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input onChange={(e) => modalData.currencyAmount = e.target.value} className=" text-right" defaultValue={modalData.currencyAmount} />
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Rate:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input onChange={(e) => modalData.exchangeValue = e.target.value} className=" text-right" defaultValue={modalData.exchangeValue} />
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Commission:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input onChange={(e) => modalData.commissionValue = e.target.value} className=" text-right" defaultValue={modalData.commissionValue} />
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Cash Handling:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input onChange={(e) => modalData.cashHandlingValue = e.target.value} className=" text-right" defaultValue={modalData.cashHandlingValue} />
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Payment Mode:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <select onChange={(e) => modalData.paymentMode = e.target.value} defaultValue={modalData.paymentMode}>
                            <option value="Cash">Cash</option>
                            <option value="Credit Card">Credit Card</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="Others">Others</option>
                        </select>
                    </div>
                </div>
                <div className=" flex justify-between  font-medium mx-4 border-b pb-3 border-black">
                    <div className='-ml-4 print-bold'>
                        Total:
                    </div>
                    <div className="item-right text-headings print-bold">
                        <input onChange={(e) => modalData.paymentAmount = e.target.value} className=" text-right" defaultValue={modalData.paymentAmount} />
                    </div>
                </div>
            </div>


            <div className='text-center print-bold'>Have a nice day.</div>
            <div className='flex justify-center'>
                <Button type='button' className='bg-red-600 text-white px-5 mr-4 save-btn' onClick={updateTransactionReport} >Update</Button>
            </div>
        </div>
    )
};


const DailyFOSReport = () => {
    const { state } = useContext(UserContext);

    const [openModal, setOpenModal] = useState(false);
    const [currencyRates, setCurrencyRates] = useState({})
    const [searchingId, setSearchingId] = useState('');
    const [searchingPayload, setSearchingPayload] = useState(searchingId);
    const [modalData, setModalData] = useState({});
    const [reports, setReports] = useState([]);
    const [totalCommission, setTotalCommission] = useState(0);
    const [startingDate, setStartingDate] = useState(new Date());
    const [endingDate, setEndingDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    // user token for API request
    const token = JSON.parse(window.localStorage.getItem("auth"))?.token;

    // userDatail  for API request
    const userDetail = JSON.parse(window.localStorage.getItem("auth"))?.user;

    useEffect(() => {
        if (userDetail && userDetail.userRole === 'Admin' && userDetail.shopId === undefined) {
            navigate('/shopSelection');
        }
    }, [])

    useEffect(() => {
        const timer = setTimeout(() => {
            setSearchingPayload(searchingId);
        }, 1000);

        // Cleanup the timeout on each render if the query changes
        return () => clearTimeout(timer);
    }, [searchingId]);

    useEffect(() => {
        handleSearchById()
    }, [searchingPayload])


    const transactions = async (startDate, endDate) => {
        setIsLoading(true)
        const allReports = await axios.post(process.env.REACT_APP_API_URL + 'getAllTransactionsByDate', {
            startDate,
            endDate
        }, {
            params: {
                shopId: userDetail?.shopId
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        setReports(allReports.data);

        const totalCommissionAmount = allReports.data.reduce((acc, item) => {
            return acc + parseInt(item.commissionAmount);
        }, 0);

        setTotalCommission(totalCommissionAmount);
        setIsLoading(false)
    }

    useEffect(() => {
        // console.log('local Token: ', token)
        transactions(startingDate, endingDate);
    }, []);

    const handleSearchById = async () => {
        setIsLoading(true)
        const allReports = await axios.post(process.env.REACT_APP_API_URL + 'getTransactionsById', {
            searchingPayload
        }, {
            params: {
                shopId: userDetail?.shopId
            },
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        setReports(allReports.data);

        const totalCommissionAmount = allReports.data.reduce((acc, item) => {
            return acc + parseInt(item.commissionAmount);
        }, 0);

        setTotalCommission(totalCommissionAmount);
        setIsLoading(false)
    }

    useEffect(() => {
        const fetchRates = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `getCurrencyRates`, {
                    params: {
                        shopId: userDetail?.shopId
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // const rates = response.data;
                // rates.AUD = 1;
                setCurrencyRates(response.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchRates();
    }, [])

    const getReportsByDate = () => {

        transactions(startingDate, endingDate);
        if (reports.length > 0) {
            // toast.success('Reports Fetched Successfully')
        } else {
            // toast.success('No Reports in the Specified Date Range')
        }
    }

    const updateTransactionReport = async () => {
        try {
            setIsLoading(true)
            const saveData = await axios.post(
                process.env.REACT_APP_API_URL + `updateTransaction`, modalData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            if (saveData.status === 200) {
                toast.success('Report Updated Successfully!')
            }
            setIsLoading(false)
        } catch (error) {
            toast.error('Error: Data not saved.');
            setIsLoading(false)
        }
        setOpenModal(false)
        getReportsByDate()
    }

    const handleEditMode = (data) => {
        setModalData(data);
        setOpenModal(val => !val)
    }

    const handleDeleteRecord = async (data) => {
        try {
            // Show confirmation toast with styled buttons
            const confirmDelete = await new Promise((resolve) => {
                toast(
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center', // Ensure vertical centering
                        textAlign: 'center', // Center the text
                        padding: '20px', // Add some padding around the content
                    }}>
                        <FaRegTrashAlt size={30} style={{
                            marginBottom: '10px',
                            color: '#FF6347'
                        }} />
                        <span style={{
                            fontSize: '16px',
                            fontWeight: '500',
                            marginBottom: '20px',
                            color: '#333'  // Adjust text color for better readability
                        }}>
                            Are you sure you want to delete this shop?
                        </span>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            {/* Yes Button */}
                            <button
                                onClick={() => {
                                    resolve(true);  // Resolve with true when Yes is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#05407F', // Red for Yes
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                Yes, Delete
                            </button>

                            {/* No Button */}
                            <button
                                onClick={() => {
                                    resolve(false);  // Resolve with false when No is clicked
                                    toast.dismiss(); // Close the toast
                                }}
                                style={{
                                    backgroundColor: '#ccc', // Gray for No
                                    color: 'black',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '5px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    transition: 'background-color 0.3s',
                                }}
                            >
                                No, Keep
                            </button>
                        </div>
                    </div>,
                    {
                        position: "top-center",
                        autoClose: false,  // Prevent auto close
                        hideProgressBar: true,  // Hide progress bar
                        closeOnClick: false,  // Prevent clicking outside to close
                        className: 'delete-toast',  // Optionally add custom class for styling
                    }
                );
            })

            if (confirmDelete) {
                // Send a GET request to delete the report
                const response = await axios.get(process.env.REACT_APP_API_URL + `deleteReport`, {
                    params: {
                        reportId: data._id
                    },
                    headers: {
                        Authorization: `Bearer ${token}` // Include the token for authorization
                    }
                });

                if (response.status === 200) {
                    // Successfully deleted the report, update the state
                    setReports((prevReports) =>
                        prevReports.filter((report) => report._id !== data._id)
                    );
                    toast.success('Report Deleted Successfully');
                }
            }
        } catch (error) {
            console.log(error);
            toast.error('Error deleting report');
        }
    };

    const colDefs = [
        {
            colId: 'index',
            headerName: '#',
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 47,
        },
        { field: "transactionId", headerName: 'Transaction No', width: 99 },
        { field: "user_name", headerName: 'Name', filter: true, width: 90 },
        { field: "localDate", headerName: 'Date', width: 105 },
        { field: "time", headerName: 'Time', width: 95 },
        // { field: "transactionMode", headerName: 'Type', filter: true, width: 110 },
        { field: "currency", headerName: 'CRY', filter: true, width: 75 },
        { field: "exchangeValue", headerName: 'Rate/AUD', width: 90 },
        { field: "currencyAmount", headerName: 'Amount', width: 85 },
        { field: '', valueFormatter: (row) => (`${row.data.commissionValue}${row.data.commissionType === 'per' ? '%' : ' AUD'}`), headerName: 'Commission %', width: 100 },
        { field: "commissionAmount", headerName: 'Commission', width: 110 },
        // { field: 'cashHandlingValue', headerName: 'Cash Handling', width: 110 },
        { field: 'paymentAmount', headerName: 'Cash', width: 80 },
        { field: 'paymentMode', headerName: 'FPOS', width: 80 },
        {
            headerName: "Edit Record",
            field: "selectDate",
            cellRenderer: (params) => (
                <div
                    className='flex'>
                    <button
                        defaultValue=''
                        type="date"
                        className={`border-0 w-7  rounded p-1 bg-#ff7675 ${params.data.transactionMode === "Sell" ? ' bg-[#ff7675] hover:bg-[#fa6666]' : 'bg-[#6FCF97] hover:bg-[#47ad71]'}`}
                        onClick={() => handleEditMode(params.data)}
                    ><FaRegEdit className={``} /></button>
                </div>
            ),
            width: 70
        },
        {
            headerName: "Delete Record",
            field: "selectDate",
            cellRenderer: (params) => (
                <div
                    className='flex'>
                    <button
                        defaultValue=''
                        type="date"
                        className={`border-0 w-7 ml- rounded p-1 bg-#ff7675 ${params.data.transactionMode === "Sell" ? ' bg-[#ff7675] hover:bg-[#fa6666]' : 'bg-[#6FCF97] hover:bg-[#47ad71]'}`}
                        onClick={() => handleDeleteRecord(params.data)}
                    ><FaTrashAlt className={``} /></button>
                </div>
            ),
            width: 75
        },
    ];

    const gridApi = useRef(null);

    const handleExport = () => {
        if (gridApi.current) {
            gridApi.current.api.exportDataAsCsv();
        }
    }

    const onGridReady = (params) => {
        gridApi.current = params.api;
        params.api.sizeColumnsToFit();
    }

    const onResize = () => {
        if (gridApi.current) {
            gridApi.current.sizeColumnsToFit();
        }
    }

    useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    const getRowStyle = params => {
        return {
            backgroundColor: params.data.transactionMode === "Sell" ? '#ff7675' : '#6FCF97',
            width: '100%',
        }
    }

    return (
        <Validate>
            {/* <h1 className="text-headings text-3xl font-medium mt-10">Reports</h1> */}

            <div className="container mx-auto px-4">
                {isLoading ? <Loader /> : ''}
                <div className="flex h-16 justify-between space-x-3 bg-white shadow-md rounded-lg p-1 box-border">
                    <div className="flex flex-col ">
                        <div className="flex ">
                            <div className=" ml-5 text-sm">{startingDate.toLocaleString('en-US', { month: 'short' }) + `/` + startingDate.getDate() + `/` + startingDate.getFullYear()}</div>
                            <div className="text-sm ml-11">{endingDate.toLocaleString('en-US', { month: 'short' }) + `/` + endingDate.getDate() + `/` + endingDate.getFullYear()}</div>
                        </div>
                        <div className="flex ">
                            <div className="h-8 border rounded-md py-1 px-2 pt-1 box-border mt-1">
                                <Label htmlFor="startingDate" className="text-md font-semibold text-gray-800 dark:text-gray-400">Start Date: </Label>
                                <input id="startingDate" type="date" className="border-0 p-0 w-5 cursor-pointer" onChange={(event) => { setStartingDate(new Date(event.target.value)) }} required />
                            </div>
                            <div className="h-8 border rounded-md py-1 px-2 pt-1 box-border ml-1 mt-1">
                                <Label htmlFor="endingDate" className="text-md font-semibold text-gray-800 dark:text-gray-400">End Date: </Label>
                                <input id="endingDate" type="date" className="border-0 p-0 w-5 cursor-pointer" onChange={(event) => { setEndingDate(new Date(event.target.value)) }} required />
                            </div>
                            <button onClick={getReportsByDate} className="bg-[#063E7C] h-8 ml-2 mt-1 hover:bg-[#3c6a9e] text-white px-2 py-1 rounded-md text-sm transition-colors"><IoIosSearch size={25} className="" /></button>
                        </div>
                    </div>
                    <div className="flex items-center space-x-2 mt-5">
                        <input
                            type="text"
                            onChange={(e) => setSearchingId(e.target.value)}
                            placeholder='Search By Number'
                            className="w-40 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                        />
                        <div className="text-black">
                            <IoIosSearch size={25} className="" />
                        </div>
                    </div>
                    {/* <Button type='button' className='h-10 mt-4 bg-gradient-to-br from-theme-primary to-theme-secondary text-white px-5 mr-5 mb-6' onClick={handleExport}>Export</Button> */}
                </div>
                <div className="ag-theme-quartz mt-3" style={{ height: 460, width: '100%', }}>
                    {/* <AgGridReact {...gridOptions} ref={gridApi} /> */}
                    <AgGridReact
                        onGridReady={onGridReady}
                        rowData={reports}
                        columnDefs={colDefs}
                        getRowStyle={getRowStyle}
                        pagination={true}
                        modules={[CsvExportModule]}
                    />
                </div>
                <div className=" mt-7 border h-10 box-border rounded-md shadow-lg">
                    <Table className="mt-[-30px]">
                        <Table.Head className=" shadow-inner">
                            <Table.HeadCell className=' shadow-none'><span className="font-medium text-lg text-white bg-theme-secondary border-theme-secondary rounded-lg px-3 py-2">Total Reports</span><span className={`ml-2 font-semibold text-3xl `}>: {reports.length}</span></Table.HeadCell>
                            <Table.HeadCell className=' shadow-none'><span className="font-medium text-lg text-white bg-theme-secondary border-theme-secondary rounded-lg px-3 py-2">Total Commission</span><span className="ml-2 font-semibold text-3xl ">: {totalCommission}</span></Table.HeadCell>
                            {/* <Table.HeadCell className=' shadow-none px-0 mx-0'><span className="font-medium text-lg text-white bg-theme-secondary border-theme-secondary rounded-lg px-3 py-2">Total</span><span className="ml-2 font-semibold text-lg ">45455/-</span></Table.HeadCell> */}
                        </Table.Head>
                    </Table>
                </div>

            </div>
            <Modal dismissible size='md' show={openModal} onClose={() => setOpenModal(false)}>
                <Modal.Body className='bg-soft-gray border-dashed border-2 border-black'>
                    <div className="space-y-6">
                        <EditableInvioce setOpenModal={setOpenModal} modalData={modalData} setModalData={setModalData} updateTransactionReport={updateTransactionReport} currencyRates={currencyRates} />
                    </div>
                </Modal.Body>
            </Modal>
        </Validate>
    )
}

export default DailyFOSReport;